import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/dhl': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M238 301.2H296.7L319 271H260.3L238 301.2zM0 282.9V289.3H81.8L86.5 282.9H0zM172.9 271C164.2 271 166.9 267.4 168.3 265.5 171.1 261.7 175.9 255.1 178.7 251.4 181.5 247.7 181.5 245.5 175.9 245.5H124.9L83.8 301.3H183.9C217 301.3 235.4 278.8 241.1 271H172.9zM490.4 264.1L529.7 210.7H467.5L428.2 264.1H490.4zM95.3 271H0V277.4H90.6L95.3 271zM206.3 244.4C203.5 248.2 198.8 254.8 196 258.6 194.6 260.6 191.9 264.1 200.6 264.1H246.2S253.5 254.1 259.7 245.7C268.1 234.3 260.4 210.7 230.5 210.7H112.6L92.2 238.5H203.6C209.2 238.5 209.1 240.7 206.3 244.4zM0 301.2H73.1L77.8 294.8H0V301.2zM323 301.2H381.7L404 271H345.3C345.2 271 323 301.2 323 301.2zM545 301.3H640V294.9H549.7L545 301.3zM567.3 271L562.6 277.4H640V271H567.3zM553.8 289.3H640V282.9H558.5L553.8 289.3zM389.6 210.7L367.1 241.3H340.9L363.4 210.7H304.7L265.4 264.1H409L448.3 210.7H389.6zM423.1 271S418.8 276.9 416.7 279.7C409.3 289.7 415.8 301.3 439.9 301.3H534.2L556.5 271H423.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/dhl.js
// module id = qQxb
// module chunks = 144